import type {
  CurrencyAmount,
  IsoDate,
  IsoDateTime,
} from '@omnipresentgroup/design-system';
import type { Country } from '../../common';
import type { BenefitOrigin, BenefitPackage, BenefitType } from '..';

export type BenefitPensionAmountAPI = {
  employer_amount: CurrencyAmount;
  employee_amount: CurrencyAmount;
  employee_voluntary_contribution_amount: CurrencyAmount;
};

export type BenefitPensionPercentageAPI = {
  employer_percentage: string;
  employee_percentage: string;
  employee_voluntary_contribution_percentage: string;
};

export type BenefitAPI = {
  benefit_effective_date: IsoDateTime;
  benefit_type: BenefitType;
  benefits_currency: string;
  client_id: string;
  country: Country;
  employee_external_id: string;
  employee_id: string;
  employee_name: string;
  employer_cost?: CurrencyAmount;
  number_of_dependents: number;
  payroll_period: string;
  vendor: string;
  origin: BenefitOrigin;
  lsp_id?: string;
  coverage?: string;
  employee_deduction?: CurrencyAmount;
  mandatory?: boolean;
  package?: BenefitPackage;
  pension_details?: BenefitPensionAmountAPI | BenefitPensionPercentageAPI;
};

export type BenefitsAPI = {
  benefits: BenefitAPI[];
  last_updated: IsoDate;
};

export const isBenefitPensionPercentageAPI = (
  benefitPension: BenefitAPI['pension_details'],
): benefitPension is BenefitPensionPercentageAPI =>
  (benefitPension as BenefitPensionPercentageAPI)?.employee_percentage !==
  undefined;

/***
 * Domain
 ***/

export type GetBenefitsResponseAPI = BenefitsAPI;
